// @ts-nocheck

import styled, { css, keyframes } from 'styled-components';

import WinaTVPath from '../../../../assets/img/channels/WinamaxTV.png';
import {
  Pause,
  Play,
  SpeakerOn,
  SpeakerOff,
  StreamFullScreen,
  FullScreenExit,
  StreamClose,
} from '../../../../assets/svg';
import { ExportStreamSvg } from '../../../../assets/svg';
import { PictureInPictureOn, PictureInPictureOff } from '../../../../assets/svg/picture-in-picture';
import { pixelToEm } from '../../../../utils/common';

export const LoaderAnimation = keyframes`
  0%, 100% {
    opacity: 1
  }
  50% {
    opacity: 0.1
  }
`;

export const VideoWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  backface-visibility: hidden;
  transform-style: preserve-3d;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;

  overflow: hidden;

  && {
    .vjs-control-bar {
      background: none;

      ${({ $isPipNativeActive }) =>
        $isPipNativeActive
          ? css`
              visibility: visible;
              opacity: 1;
            `
          : css`
              visibility: hidden;
              opacity: 0;
            `}
    }

    // hide the native video-js play button when we start a streaming video
    .vjs-big-play-button {
      display: none;
    }

    .vjs-loading-spinner {
      position: relative;
      border: none;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      margin: 0;
    }

    .vjs-loading-spinner::after {
      position: absolute;
      top: 0;
      left: 0;
      margin: 0;
      content: '';
      height: 100%;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      background: url(${WinaTVPath});
      background-repeat: no-repeat;
      background-position: center;
      background-size: 50%;
      animation: ${LoaderAnimation} 1.1s linear infinite;
    }
  }
`;

export const PlayerLoader = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  z-index: 1; // make the loader always on top of the video

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    top: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    animation: ${LoaderAnimation} 1.1s linear infinite;
    background: url(${WinaTVPath});
    background-position: center;
    background-repeat: no-repeat;
    background-size: 50%;
  }
`;

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

export const Controls = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  transition: opacity 300ms ease-out;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${({ $isVisible, $isFullscreen, $showPipControls }) => css`
    height: 100%;
    pointer-events: ${$isVisible ? 'auto' : 'none'};
    opacity: ${$isVisible ? 1 : 0};
    background-color: ${$isFullscreen ? 'transparent' : 'rgba(0, 0, 0, 0.3)'};
    font-size: ${$showPipControls ? '0.8em' : '1em'};
  `}
`;

export const Button = styled.button`
  position: relative;
  background: transparent;
  height: 2.7em;
  width: 2.7em;
  margin: unset; // reset of Button default margin style to avoir bad side effects
  padding: 0;
  ${({ $isPipCustomActive }) =>
    $isPipCustomActive
      ? css`
          display: none;
        `
      : undefined}
}
`;

export const commonStyledPicto = css`
  width: 100%;
  height: 100%;
`;

export const ExportStreamIcon = styled(ExportStreamSvg)`
  ${commonStyledPicto}
`;

export const PictureInPictureActivateIcon = styled(PictureInPictureOff)`
  ${commonStyledPicto}
`;

export const PictureInPictureRestoreIcon = styled(PictureInPictureOn)`
  ${commonStyledPicto}
`;

export const PictureInPictureCloseIcon = styled(StreamClose)`
  ${commonStyledPicto}
`;

export const StyledPlay = styled(Play)`
  ${commonStyledPicto}
`;

export const StyledPause = styled(Pause)`
  ${commonStyledPicto}
`;

export const StyledFullScreen = styled(StreamFullScreen)`
  ${commonStyledPicto}
`;

export const StyledFullScreenExit = styled(FullScreenExit)`
  ${commonStyledPicto}
`;

export const StyledSpeakerMuted = styled(SpeakerOff)`
  ${commonStyledPicto}
`;

export const StyledSpeaker = styled(SpeakerOn)`
  ${commonStyledPicto}
`;

export const TopContainer = styled.div`
  flex: 1;
  padding: ${pixelToEm(5)}em;

  align-items: flex-start;
  flex-direction: row-reverse;
  display: flex;
  justify-content: space-between;
`;

export const BottomContainer = styled.div`
  flex: 1;
  padding: ${pixelToEm(5)}em;

  display: flex;
  align-items: flex-end;
  justify-content: space-between;
`;

export const LeftContainer = styled.div`
  flex: 1;

  display: flex;
  justify-conten: flex-start;
  z-index: 1;
`;

export const RightContainer = styled.div`
  flex: 1;

  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  z-index: 1;
`;

export const RightContent = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;

  > *:not(:last-child) {
    margin-right: ${pixelToEm(20)}em;
  }
`;

export const PlayWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  cursor: pointer;

  ${StyledPlay} {
    width: 15%;
  }
`;
